import "./index.scss";
import { ReactElement, useState } from "react";
import { Trans } from "react-i18next";
import { createPortal } from "react-dom";

interface EnhanceModalProps {
  visible: boolean;
  onCancel: () => void;
  title: string | ReactElement;
  children?: ReactElement;
  onConfirm?: Function;
}

const EnhanceModal = ({ visible, onCancel, onConfirm, title, children }: EnhanceModalProps) => {
  if (visible) {
    return createPortal(
      <div className="Component-EnhanceModal ">
        <div className="content">
          <div className="title">
            <Trans>{title}</Trans>
          </div>
          <div className="desc">{children}</div>
          <div className="btns">
            <div className="btn cancel" onClick={onCancel}>
              <Trans>Cancel</Trans>
            </div>
            <div
              className="btn confirm"
              onClick={() => {
                onConfirm?.();
              }}
            >
              <Trans>Agree</Trans>
            </div>
          </div>
          {/* <IconClose className="icon-close" onClick={onCancel}></IconClose> */}
        </div>
      </div>,
      document.body,
    );
  }
  return null;
};

export default EnhanceModal;

export const useEnhanceModal = ({ title, onConfirm, content, onCancel }: any) => {
  const [visible, setVisible] = useState(false);
  const EnhanceModalDom = (
    <EnhanceModal
      title={title}
      onConfirm={() => {
        setVisible(false);
        onConfirm?.();
      }}
      visible={visible}
      onCancel={() => {
        setVisible(false);
        onCancel?.();
      }}
    >
      {content}
    </EnhanceModal>
  );
  return {
    EnhanceModalDom,
    setVisible: (vis: boolean) => setVisible(vis),
  };
};
